import React, { Component, Suspense, lazy } from "react";
import { connect } from "react-redux";
import { Col, Tabs, Tab } from "react-bootstrap";

import { getConfigs } from "../../Config/config.actions";
import { Route, Switch, Redirect } from "react-router-dom";
import { getDistributorList } from "../../../components/distributors/distributors.actions";
import { getNewDistributorList } from "../../Admin/admin.actions";
import { getAllRestaurants } from "../../Restaurant/restaurant.actions";
import { getInvalidOrdersCount } from "../../orders/invalidOrders.actions";
import { getPrintersByApi } from "../../Printer/printer.actions";
import Logout from "../../../components/logout/Logout";
import translator from "../../../components/localization/translator";

import security from "../../../components/common/security/security";

import pkg from "../../../../package.json";

import {
    USER_ROLE_NAMES,
    USER_ROLES,
} from "../../../config/constants";
import tabsConf from "../../../config/tabs";
import "./Pages.css";

const { version } = pkg;

const OrderTable = lazy(() => import("../../orders/templates/OrderTable"));
const DeliveredOrders = lazy(() =>
    import("../../DeliveredOrders/templates/DeliveredOrders"),
);
const DeliveredOrdersCopy = lazy(() =>
    import("../../DeliveredOrders/templates/DeliveredOrdersCopy"),
);

const BookedOrders = lazy(() =>
    import("../../BookedOrders/templates/BookedOrders"),
);
const Admin = lazy(() => import("../../Admin/templates/Admin"));
const DispatchConfigs = lazy(() =>
    import("../../DispatchConfig/templates/DispatchConfigs"),
);
const SuppliersAutomaticReport = lazy(() =>
    import("../../SuppliersAutomaticReport/templates/SuppliersAutomaticReport"),
);
const DeactivatedUsers = lazy(() =>
    import("../../DeactivatedUsers/templates/DeactivatedUsers"),
);
const Terminal = lazy(() => import("../../Terminal/templates/Terminal"));
const Salary = lazy(() => import("../../Salary/templates/Salary"));
const Printer = lazy(() => import("../../Printer/templates/printer"));

const InvalidOrders = lazy(() =>
    import("../../orders/templates/InvalidOrders"),
);
const B2bUsersTotalDebt = lazy(() =>
    import("../../B2bUsersReport/templates/b2bUsersTotalDebt"),
);
const B2bUsers = lazy(() => import("../../B2bUsers/templates/b2bUsers"));
const B2bUsersReport = lazy(() =>
    import("../../B2bUsersReport/templates/b2bUsersReport"),
);
const Schedule = lazy(() => import("../../Schedule/template/Schedule"));
const QuantitativeTabs = lazy(() =>
    import("../../QuantitativeMovement/templates/quantitativeTabs"),
);
const GiftCard = lazy(() => import("../../GiftCard/templates/giftCard"));
const Balance = lazy(() => import("../../Balance/templates/Balance"));
const Finance = lazy(() => import("../../Finance/templates/Finance"));
const Restaurant = lazy(() => import("../../Restaurant/templates/Restaurant"));
const Tickets = lazy(() => import("../../tickets/templates/Tickets"));
const CanceledOrders = lazy(() =>
    import("../../CanceledOrders/templates/CanceledOrders"),
);
const CallCenter = lazy(() => import("../../CallCenter/templates/CallCenter"));
const DistributorMap = lazy(() =>
    import("../../../components/maps/DistributorMap"),
);
const ManagerReport = lazy(() =>
    import("../../ManagersReport/templates/Report"),
);
const Refund = lazy(() => import("../../refund/templates/refund"));
const DeliveryPriceReport = lazy(() =>
    import("../../DeliveryPriceReport/templates/deliveryPriceReport"),
);
const HdmPrintReport = lazy(() =>
    import("../../HdmPrintReport/templates/HdmPrintReport"),
);
const DeedReport = lazy(() => import("../../DeedReport/templates/DeedReport"));
const SettingDeliveryService = lazy(() => import("../../SettingDeliveryService/templates/SettingDeliveryService"));
const CourierMutualSettlements = lazy(() => import("../../CourierMutualSettlements/templates/CourierMutualSettlements"));
const CourierSettlementDetails = lazy(() => import("../../CourierMutualSettlements/templates/CourierSettlementDetails"));
const Distributors = lazy(() =>
    import("../../Distributors/templates/Distributors"),
);

class Pages extends Component {
    componentDidMount() {
        this.props.getDistributorList();
        this.props.getNewDistributorList();
        this.props.getAllRestaurants();
        this.props.getConfigs();

        const role = security.getUser().role;

        if ([USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN].includes(role)) {
            this.props.getInvalidOrdersCount();
        }
    }

    getTabs() {
        const userRole = security.getUser().role;
        return tabsConf
            .getTabs(userRole)
            .filter(tab => !(
                tab.isBalance ||
                tab.isTurnover ||
                tab.isTurnoverDetails ||
                tab.isTerminal ||
                tab.isDeactivatedUsers ||
                tab.isSuppliersAutomaticReport ||
                tab.isB2bUsersTotalDebt ||
                tab.isMaterialMeansReport ||
                tab.isDistributorSalaryReport ||
                tab.isB2bUsersReport
            ));
    }

    getRoleName() {
        const user = security.getUser();
        const roleObj = USER_ROLE_NAMES.find(u => u.role === user.role);
        return roleObj ? translator.translate(roleObj.label) : "";
    }

    changeTab(tab) {
        this.props.history.push("/orders" + tab);
    }

    renderInvalidOrdersCount(tab) {
        if (tab.isInvalidOrders && this.props.invalidOrders.total) {
            return (
                <span className={"label label-danger"}>
                    {" "}
                    {this.props.invalidOrders.total}{" "}
                </span>
            );
        }
    }

    render() {
        let tabs = this.getTabs();
        return (
            <Col className="page-content">
                <div className="border-around">
                    <Tabs
                        defaultActiveKey="/"
                        id="order-management"
                        onSelect={this.changeTab.bind(this)}
                    >
                        {tabs.map((tab) => {
                            if (
                                tab.isBalance ||
                                tab.isTurnover ||
                                tab.isTurnoverDetails ||
                                tab.isTerminal ||
                                tab.isDeactivatedUsers ||
                                tab.isSuppliersAutomaticReport ||
                                tab.isB2bUsersTotalDebt ||
                                tab.isMaterialMeansReport ||
                                tab.isDistributorSalaryReport ||
                                tab.isB2bUsersReport
                            ) {
                                return null;
                            }
                            return (
                                <Tab
                                    eventKey={tab.path}
                                    title={
                                        <div>
                                            {translator.translate(tab.title)}
                                            {this.renderInvalidOrdersCount(tab)}
                                        </div>
                                    }
                                    key={tab.title}
                                ></Tab>
                            );
                        })}

                        <Suspense fallback={<div>Loading...</div>}>
                            <Switch>
                                <Route path="/orders" exact render={(props) => <Admin {...props} />} />
                                <Route path="/orders/delivered" component={DeliveredOrders} />
                                <Route path="/orders/updated/delivered" component={DeliveredOrdersCopy} />
                                <Route
                                    path="/orders/distributors"
                                    render={(props) =>
                                        [USER_ROLES.ADMIN, USER_ROLES.SUPER_ADMIN].includes(security.getUser().role) ? (
                                            <Distributors {...props} />
                                        ) : (
                                            <Redirect to="/orders/active" />
                                        )
                                    }
                                />
                                <Route path="/orders/booked" component={BookedOrders} />
                                <Route
                                    path="/orders/active"
                                    render={(props) => <OrderTable {...props} />}
                                />
                                <Route path="/orders/canceled" component={CanceledOrders} />
                                <Route
                                    path="/orders/map"
                                    render={(props) => <DistributorMap {...props} />}
                                />
                                <Route
                                    path="/orders/callCenter"
                                    render={(props) => <CallCenter {...props} />}
                                />
                                <Route path="/orders/partner" component={Restaurant} />
                                <Route path="/orders/giftCard" component={GiftCard} />
                                <Route path="/orders/other" component={Tickets} />
                                <Route path="/orders/printer" component={Printer} />
                                <Route
                                    path="/orders/finance"
                                    render={(props) => <Finance {...props} />}
                                />
                                <Route path="/orders/balance" render={() => <Balance isBalance />} />
                                <Route
                                    path="/orders/turnover"
                                    render={(props) => <Balance isTurnover {...props} />}
                                />
                                <Route
                                    path="/orders/turnoverDetails"
                                    render={() => <Balance isTurnoverDetails />}
                                />
                                <Route
                                    path="/orders/materialMeansReport"
                                    render={() => <Balance isMaterialMeansReport />}
                                />
                                <Route
                                    path="/orders/distributorSalaryReport"
                                    render={() => <Balance isDistributorSalaryReport />}
                                />
                                <Route
                                    path="/orders/distributorSaveReport"
                                    render={() => <Balance isDistributorSaveReport />}
                                />
                                <Route path="/orders/terminal" component={Terminal} />
                                <Route path="/orders/salary" component={Salary} />
                                <Route path="/orders/deactivatedUsers" component={DeactivatedUsers} />
                                <Route
                                    path="/orders/suppliersAutomaticReport"
                                    component={SuppliersAutomaticReport}
                                />
                                <Route
                                    path="/orders/quantitativeMovement"
                                    component={QuantitativeTabs}
                                />
                                <Route path="/orders/b2bUsersReport" component={B2bUsersReport} />
                                <Route path="/orders/b2bUsers" component={B2bUsers} />
                                <Route path="/orders/b2bUsersTotalDebt" component={B2bUsersTotalDebt} />
                                <Route path="/orders/invalidOrders" component={InvalidOrders} />
                                <Route path="/orders/distributorSchedule" component={Schedule} />
                                <Route path="/orders/dispatchConfigs" component={DispatchConfigs} />
                                <Route path="/orders/managerReport" component={ManagerReport} />
                                <Route path="/orders/refund" component={Refund} />
                                <Route path="/orders/deliveryPriceReport" component={DeliveryPriceReport} />
                                <Route path="/orders/hdmPrintReport" component={HdmPrintReport} />
                                <Route path="/orders/deedReport" component={DeedReport} />
                                <Route path="/orders/deliveryService" component={SettingDeliveryService} />
                                <Route
                                    path="/orders/courier/settlement/details"
                                    component={CourierSettlementDetails}
                                />
                                <Route
                                    path="/orders/courier/settlement"
                                    component={CourierMutualSettlements}
                                />
                            </Switch>
                        </Suspense>
                    </Tabs>

                    <div className="logout-container">
                        <span className={"text-no-wrap"}>
                            {`${
                                security.getUser().name
                            } | ${this.getRoleName()}`}
                        </span>
                    </div>
                    <div className="logout-container">
                        <Logout history={this.props.history} />
                    </div>
                </div>
                <div className="footer">
                    <div>{translator.translate("_copyright_")}</div>
                    <div>{`${translator.translate(
                        "_version_",
                    )}: v${version}`}</div>
                </div>
            </Col>
        );
    }
}

let mapStateToProps = (state) => {
    return {
        newDistributors: state.newDistributors || [],
        invalidOrders: state.invalidOrders,
    };
};

export default connect(mapStateToProps, {
    getDistributorList,
    getNewDistributorList,
    getAllRestaurants,
    getPrintersByApi,
    getInvalidOrdersCount,
    getConfigs,
})(Pages);
